import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostOfNotHaving() {
  const costs = ['Más ansiedad innecesaria', 'Más miedo por no saber qué es normal', 'Más sobreinformación que abruma', 'Dudas constantes', 'Sensación de estar sola', 'Buscar respuestas desesperadamente en internet', 'Más angustia y más inseguridad', 'Vivir esta etapa con más miedo que tranquilidad'];
  return <section className="py-20 md:py-28 bg-peach-light/20" data-id="element-63">
      <div className="max-w-4xl mx-auto px-6" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-66">
            ⚖️ EL COSTO DE NO TENERLO
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-67">
            ¿Cuánto cuesta no tenerlo?
          </h2>
          <p className="font-serif italic text-xl text-peach-dark" data-id="element-68">
            Sin esta guía:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-69">
          {costs.map((cost, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.05
        }} className="flex items-center gap-3 bg-white p-5 rounded-2xl shadow-sm border border-red-100/50" data-id="element-70">
              <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-71">
                <X className="w-4 h-4 text-red-400" strokeWidth={2.5} data-id="element-72" />
              </div>
              <span className="text-text-dark" data-id="element-73">{cost}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}